import config from './config-service';

export default {
    config,
};
